import { locationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const createConsolidationFulfillmentGroup = {
  name: "createConsolidationFulfillmentGroup" as const,
  input: z.object({
    teamId: z.string(),
    originLocationId: locationIdFormat.schema,
  }),
  output: z.object({ fulfillmentGroupId: z.string() }),
};
